import { useLocation, Link } from "react-router-dom"
import { useEffect } from "react"
import { useLanguage } from "@/hooks/useLanguage"

const NotFound = () => {
  const location = useLocation()
  const { t } = useLanguage()
  const text = t.notFound

  // 404 tracking removed for production

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 pt-8">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">{text.title}</h1>
        <p className="mb-4 text-xl text-gray-600">{text.message}</p>
        <Link to="/" className="text-blue-500 underline hover:text-blue-700">
          {text.backHome}
        </Link>
      </div>
    </div>
  )
}

export default NotFound

